import { Map } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as deviceNavActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';
import type { DeviceNavNode, DeviceNavTab } from 'src/service/api/deviceNav';

/* Values are plain JS, set with .set() only. */
export const initialState = Map<string, any>({
  tab: null as DeviceNavTab | null,
  items: [] as DeviceNavNode[],
  total: null as number | null,
  loading: false,
  error: null,
  addConnectionOpen: false,
  creatingConnection: false,
});

const reset = () => initialState;

export const deviceNavReducer = createTypedReducer(initialState, {
  [deviceNavActions.FETCH_DEVICE_NAV] (state, action) {
    let nextState = state;
    if (state.get('tab') !== action.tab) {
      nextState = state
        .set('tab', action.tab)
        .set('items', initialState.get('items'))
        .set('total', initialState.get('total'));
    }
    return nextState.set('loading', true).set('error', null);
  },

  [deviceNavActions.FETCH_DEVICE_NAV_SUCCESS] (state, action) {
    if (action.nav.by !== state.get('tab')) {
      return state;
    }
    return state.withMutations((nextState) =>
      nextState
        .set('items', action.nav.items)
        .set('total', action.nav.total)
        .set('loading', false)
    );
  },

  [deviceNavActions.FETCH_DEVICE_NAV_FAILED] (state, action) {
    return state.set('loading', false).set('error', action.err);
  },

  [deviceNavActions.OPEN_ADD_CONNECTION] (state) {
    return state.set('addConnectionOpen', true);
  },

  [deviceNavActions.CLOSE_ADD_CONNECTION] (state) {
    return state.set('addConnectionOpen', false);
  },

  [deviceNavActions.CREATE_CONNECTION] (state) {
    return state.set('creatingConnection', true);
  },

  [deviceNavActions.CREATE_CONNECTION_SUCCESS] (state) {
    return state.set('creatingConnection', false).set('addConnectionOpen', false);
  },

  [deviceNavActions.CREATE_CONNECTION_FAILED] (state) {
    return state.set('creatingConnection', false);
  },

  [CHANGE_CLIENT]: reset,
  [CLEAR]: reset,
});
